<script>
    import {_} from '../lib/i18n';
    export let params;
    let path = '';
    $: path = (params && params.path) ? params.path : '';

    import {Link} from "svelte-routing";
</script>

<section class="payment-error-block system-info system-info_red">
    <div class="payment-error-block__title-wrapper system-info__title-wrapper">
        <div class="payment-error-block__title-icon system-info__title-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="10.0001" cy="14.1668" rx="0.833333" ry="0.833333" fill="#C93329"></ellipse>
                <path d="M10 8.3335L10 11.6668" stroke="#C93329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M3.11396 14.6057L8.21123 4.4112C8.94828 2.93711 11.0519 2.93711 11.7889 4.4112L16.8862 14.6057C17.5511 15.9355 16.5841 17.5002 15.0973 17.5002H4.90282C3.41605 17.5002 2.44906 15.9355 3.11396 14.6057Z" stroke="#C93329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        </div>
        <h3 class="payment-error-block__title-text system-info__title-text">
            {@html $_('subscriptionExpiredAlert.title')}
        </h3>
    </div>
    <p class="payment-error-block__text system-info__text">
        {@html $_('subscriptionExpiredAlert.description')}
    </p>
    <div class="payment-error-block__ system-info__controls-wrapper">
        <Link to={`${path}/dashboard/subscription`}
           class="button button_ghost system-info__controls-btn system-info__controls-btn_main payment-error-block__btn">
            {$_('subscriptionExpiredAlert.selectTariffBtnLabel')}
        </Link>
    </div>
</section>